var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIconFlights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "17px",
    viewBox: "0 0 22 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "airplane-ticket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation/Sidebar/Dashboard",
    transform: "translate(-39.000000, -225.000000)",
    fill: "#8E929A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Menu",
    transform: "translate(0.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flights",
    transform: "translate(39.000004, 143.174393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "airplane-ticket",
    transform: "translate(0.000000, 4.035078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6343739,3.27495853 L20.3807149,1.83613825 C20.1929546,0.772129032 19.1975813,0 18.0138394,0 C17.854973,0 17.694079,0.0140921659 17.5358209,0.0419723502 L2.09080709,2.76510599 C0.738972991,3.00335484 -0.184925627,4.19632258 0.0314246036,5.4241659 L0.0486596266,5.52139171 L0.0486596266,13.4525438 C0.0486596266,14.7563226 1.21861354,15.8169862 2.65692691,15.8169862 L19.3618209,15.8169862 C20.8001343,15.8169862 21.9700882,14.7563226 21.9700882,13.4525438 L21.9700882,5.33677419 C21.9700882,4.45200922 21.4304292,3.68028571 20.6343739,3.27495853 Z M17.7687979,1.36237788 C17.8497306,1.34806708 17.9317526,1.34080789 18.0139407,1.34068203 C18.5457933,1.34068203 18.9858946,1.64705991 19.0603094,2.06881106 L19.2196827,2.97212903 L8.63889926,2.97212903 L17.7687979,1.36237788 L17.7687979,1.36237788 Z M20.6292034,13.4527465 C20.6292034,14.0170415 20.0606504,14.4763041 19.3618209,14.4763041 L2.65692691,14.4763041 C1.95809741,14.4763041 1.38954442,14.0170415 1.38954442,13.4527465 L1.38954442,5.33677419 C1.38954442,4.77247926 1.95809741,4.31321659 2.65692691,4.31321659 L19.3618209,4.31321659 C20.0606504,4.31321659 20.6292034,4.77247926 20.6292034,5.33677419 L20.6292034,13.4527465 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "6.00711124 9.97157604 7.34799603 9.97157604 7.34799603 11.1256129 6.00711124 11.1256129"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "6.00711124 12.2799539 7.34799603 12.2799539 7.34799603 13.4339908 6.00711124 13.4339908"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "6.00711124 5.35552995 7.34799603 5.35552995 7.34799603 6.50956682 6.00711124 6.50956682"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "6.00711124 7.6635023 7.34799603 7.6635023 7.34799603 8.81753917 6.00711124 8.81753917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2278854,6.92665438 L15.255526,7.96582488 L12.170761,7.04243318 L11.6498578,7.56313364 C11.5930836,7.62031336 11.5930836,7.71287558 11.6500605,7.76964977 L14.1510652,9.14632258 L12.893314,10.4257696 L11.9207518,10.2275668 L11.5962264,10.5522949 C11.5755485,10.5729304 11.5639281,10.6009436 11.5639281,10.6301567 C11.5639281,10.6593697 11.5755485,10.687383 11.5962264,10.7080184 L13.4321619,12.5439539 C13.4753189,12.5867387 13.5449519,12.5865574 13.5878854,12.5435484 L13.9124108,12.2192258 L13.7092403,11.2283134 L14.9837195,9.97117051 L16.3697195,12.4898157 C16.3971085,12.5172729 16.4342969,12.5327039 16.473079,12.5327039 C16.5118611,12.5327039 16.5490495,12.5172729 16.5764384,12.4898157 L17.0971389,11.9691152 L16.1676642,8.86376959 L17.1992311,7.89850691 C17.4833048,7.61443318 17.4955721,7.16682949 17.2274154,6.8981659 C16.9593601,6.62960369 16.5119592,6.64258065 16.2278854,6.92665438 L16.2278854,6.92665438 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconFlights);
export default __webpack_public_path__ + "static/media/sidebar-icon-flights.523d625f.svg";
export { ForwardRef as ReactComponent };